<router-outlet></router-outlet>
<!-- <button (click)="addToHomeScreen()" class="p-3 m-4">aA</button>
<button class="add-button p-3 m-4">Add to home screen</button> -->

<!-- <button (click)="onbeforeinstallprompt($event)" class="p-3 m-4">aA45</button> -->
<!-- <img src="../../ngsw-config.json" alt=""> -->
<!-- <button (click)="onbeforeinstallprompt($event)">2323</button> -->
<!-- <div>
    <h2>{{ 'HOME.TITLE' | translate }}</h2> 
    <label>
      {{ 'HOME.SELECT' | translate }}
      <select #langSelect (change)="changeLAng(langSelect.value)" (change)="translate.use(langSelect.value)">
        <option *ngFor="let lang of translate.getLangs()" [value]="lang" [selected]="lang === defaultLang">{{ lang }}</option>
      </select>
    </label>
{
  "erp_base_url_account": "http://50.117.116.114:8080/campasales",
  "erp_base_url_auth": "http://50.117.116.114:8080/campaauth",
  "erp_base_url_master": "http://50.117.116.114:8080/campamaster",
  "erp_base_url_sale": "http://50.117.116.114:8080/campasales",
  "erp_base_url_inventory": "http://50.117.116.114:5000",
  "erp_base_url_purchaseService": "http://50.117.116.114:5561",

  "erp_base_url_fixedAsset": "http://50.117.116.114:5055",
  "erp_base_url_investment": "http://50.117.116.114:4077",
  "erp_base_url_report": "http://50.117.116.114:4066"
}
  </div> -->
